originalExec